var React = require('react');

function Calendar (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","d":"M5 5h15a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1zm1.5 5a.5.5 0 0 0-.5.5v7a.5.5 0 0 0 .5.5h12a.5.5 0 0 0 .5-.5v-7a.5.5 0 0 0-.5-.5h-12z"}));
}

Calendar.defaultProps = {"width":"17","height":"17","viewBox":"0 0 25 25"};

module.exports = Calendar;

Calendar.default = Calendar;
